import { useState } from 'react';
import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { EXTERNAL_FORM_DEFAULTS } from '@/features/externalForm/constants';
import { PublicFormShell } from '@/features/externalForm/components/PublicFormShell';
import { CreateQuotationHeader } from './Header';
import { CreateQuotationMain } from './Main';
import { CreateQuotationRightSidebar } from './RightSidebar';

export const CreateQuotationLayout = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const externalSession = localStorage.getItem('external_session') === 'true'; // TODO: pendiente pasar a zustand
  const externalForm = useSelector((state) => state.initialData.externalForm) || EXTERNAL_FORM_DEFAULTS;

  const onNext = () => setCurrentStep((prev) => prev + 1);
  const onPrevious = () => setCurrentStep((prev) => prev - 1);

  const content = (
    <Row gutter={[16, 32]}>
      <Col span={24}>
        <CreateQuotationHeader
          isExternal={externalSession}
          title={externalForm.title}
          subtitle={externalForm.subtitle}
          logo={externalForm.logo}
        />
      </Col>
      <Col
        xs={{ span: 24, order: 2 }}
        lg={{ flex: '1', order: 1 }}
      >
        <CreateQuotationMain currentStep={currentStep} onNext={onNext} onPrevious={onPrevious} isExternal={externalSession} />
      </Col>
      <Col
        xs={{ span: 24, order: 1 }}
        lg={{ flex: '0 0 320px', order: 2 }}
      >
        <CreateQuotationRightSidebar currentStep={currentStep} />
      </Col>
    </Row>
  );

  if (!externalSession) return content;

  return (
    <PublicFormShell form={externalForm} currentStep={currentStep}>
      <CreateQuotationMain currentStep={currentStep} onNext={onNext} onPrevious={onPrevious} isExternal />
    </PublicFormShell>
  );
};
